import { createFileRoute } from "@tanstack/react-router";
import ShowroomConfigure from "lib/components/showroom2/pages/ShowroomConfigure";
import { ShowroomProvider } from "lib/components/showroom2/state/useShowroomState";
import { useAppRouterParams } from "lib/routeHelpers";
import withAuthentication from "../../components/withAuthentication";

/**
 * Showroom preview of an in-progress Studio doc. Fetches the doc by
 * `studioDocId` and injects it as fake plan data so the normal showroom
 * viewer can render a design that isn't yet a published plan.
 */
function ShowroomStudio() {
  const { studioDocId, builderId } = useAppRouterParams();
  const showroomKey = [builderId, studioDocId].filter(Boolean).join("-") || undefined;

  return (
    <ShowroomProvider key={showroomKey}>
      <ShowroomConfigure />
    </ShowroomProvider>
  );
}

export const Route = createFileRoute("/showroom/studio")({
  component: withAuthentication(ShowroomStudio, {
    features: ["showroomUnification"],
    products: ["showroom"],
  }),
});
